import { IConnectionDrawingOptions } from '..';
import {
	ProjectState,
	ActionDescriptorState,
	LoopState,
	ChangeSet,
	ChangeSetEntityChangeType,
} from '@elyx-code/project-logic-tree';
import { connectPassthroughCallable } from './utils';

export function createLoopFromActionDescriptor(
	from: ActionDescriptorState,
	connectionOptions: IConnectionDrawingOptions,
	project: ProjectState,
	changeSet: ChangeSet
): LoopState {
	// Create a new function-declaration that implements the abstract entity
	const newLoop = from.implementAsLoop(changeSet);

	changeSet.add(newLoop, ChangeSetEntityChangeType.Added);

	connectPassthroughCallable(newLoop, connectionOptions, project, changeSet);

	return newLoop;
}
